export const PROTECTED_DATA_PREFIX = 'licensed_data';
export const PROTECTED_DATA_REGEXP = new RegExp(`^${PROTECTED_DATA_PREFIX}\\[((?<type>\\w+):)?(?<size>\\d+)\\]$`);
export const PLACEHOLDER = '*';
export const UNKNOWN = 'UNKNOWN'.replace(/./g, PLACEHOLDER);
